exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-page[data-v-1d6ddaf6]{padding-bottom:2rem}.dashboard-section-title[data-v-1d6ddaf6]{font-weight:700}.dashboard-range-controls[data-v-1d6ddaf6]{gap:.5rem}.dashboard-date-picker[data-v-1d6ddaf6]{width:9.5rem}.dashboard-sales-rep-select[data-v-1d6ddaf6]{width:12rem}.dashboard-sales-rep-select[data-v-1d6ddaf6] .vue-treeselect__control{height:31px;min-height:31px}.dashboard-sales-rep-select[data-v-1d6ddaf6] .vue-treeselect__placeholder,.dashboard-sales-rep-select[data-v-1d6ddaf6] .vue-treeselect__single-value{line-height:29px}@media (min-width:1200px){.dashboard-col-fifth[data-v-1d6ddaf6]{flex:0 0 20%;max-width:20%}}", ""]);

// exports
